// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__27Quc","header":"ClearentDisclaimer_header__2M17K","inner":"ClearentDisclaimer_inner__1-3c7"};